import React from "react";
import { XBEcard } from "./XBEcard";
export function XBEother({ children }) {
  return (
    <div className="l_block">
      <div className="l_content" style={{zIndex:1}}>
        <div className="l_content_center">
          <div className="l_width_1160">



              <div className="l_paddings_m_bot">
                  {children}
                </div>


          </div>
        </div>
        {/* <div className="l_block_bg l_block_bg--light  x_hide-34" style={{zIndex:0}} /> */}
        {/* <div className="l_block_bg l_block_bg--mob" style={{zIndex:0}}></div> */}
      </div>
      <div className="l_block_bg l_block_bg--xbe--grad" style={{zIndex:0}}>
        <div className="l_block_bg_pa" />
      </div>
    </div>
  );
}
